$(function() {

    if($('.navbar-search-btn')[0]) {
    const $overlay = $('#search-modal-overlay');
    const $input   = $('#navbar-search-input');

    $overlay.hide();

    $('.navbar-search-btn').on('click', function (e) {
        e.preventDefault();
        $overlay.show();
        setTimeout(() => $input.on('focus',50));
    });

    $('#close-search-modal').on('click', function () {
        $overlay.hide();
    });

    $overlay.on('click', function (e) {
        if (!$(e.target).closest('#search-modal').length) {
            $overlay.hide();
        }
    });

    $(document).on('keydown', function (e) {
        if (e.key === 'Escape') $overlay.hide();
    });

    $('#navbar-search-form').on('submit', function (e) {
        e.preventDefault();
        const keyword = $input.val().trim();
        if (!keyword) return;
        window.location.href = '/search-results/?keyword=' + encodeURIComponent(keyword);
    });
  }
})